export const launchHero = {
  eyebrow: '0# 首发验证',
  title: '从 0# 开始验证',
  titleHighlight: '帝星数商综合体',
  subtitle: '帝星咖啡：从一家消费场景，升级为九畴云市的 0# 数商综合体验证场。',
  desc: '项目文件明确将帝星咖啡定位为「万村万店振兴乡村首发」场景、0 号数商综合体，而不是简单的一家咖啡店；其背后连接京客隆百店、千县万村供应链和数字消费通道。',
};

export const launchPlan = [
  {
    icon: 'ri-store-2-line',
    title: '定位升级',
    desc: '从一家咖啡消费场景，升级为九畴云市 0# 数商综合体验证场，成为城市端验证的第一现场。',
  },
  {
    icon: 'ri-building-2-line',
    title: '京客隆百店',
    desc: '连接京客隆百店渠道，打通城市消费场景与既有供应链资源。',
  },
  {
    icon: 'ri-git-branch-line',
    title: '千县万村供应链',
    desc: '对接千县万村供应链，为农产品数字化上行提供标准化通道。',
  },
  {
    icon: 'ri-red-packet-line',
    title: '数字消费通道',
    desc: '以红包、权益、核销构成的数字消费通道，验证「3 秒红包到账」目标。',
  },
];

export const firstTrade = {
  title: '首笔交易',
  desc: '九畴云市在 0# 帝星场景完成的首笔交易，验证了「数字货架 + ePin 数字身份 + 数字消费 + 智能清分」的完整闭环。',
  steps: [
    { icon: 'ri-qr-scan-line', label: '扫码进入', desc: '消费者通过车载卡 / 手机扫码进入云铺' },
    { icon: 'ri-store-2-line', label: '数字货架下单', desc: '在数字货架完成商品浏览与下单' },
    { icon: 'ri-red-packet-line', label: '红包到账', desc: '红包实时到账，目标 3 秒内完成' },
    { icon: 'ri-qr-code-line', label: 'ePin 存证', desc: '商品 ePin 数字身份记录溯源信息' },
    { icon: 'ri-flow-chart', label: '智能清分', desc: '多方协同自动结算，交易沉淀为数据链' },
  ],
};

export const techDeploy = [
  {
    icon: 'ri-robot-2-line',
    title: 'TOMA 智能体',
    desc: '掌中智能体作为 AI 交互入口，承载美食社交、健康管家与数字服务。',
  },
  {
    icon: 'ri-store-2-line',
    title: '数字货架',
    desc: '首批 10—20 个数字货架商品完成数字化上架。',
  },
  {
    icon: 'ri-router-line',
    title: '车载卡激活系统',
    desc: '华辉数智承担车载卡激活系统的核心技术交付。',
  },
  {
    icon: 'ri-dashboard-3-line',
    title: '数据看板',
    desc: '实时呈现会员、交易、消费卡与云铺激活等核心指标。',
  },
];

export const launch0Stats = [
  { value: '4万+', label: '帝星存量会员种子用户' },
  { value: '1000', label: '首批消费卡' },
  { value: '10000', label: '满额发行规模' },
  { value: '10—20', label: '首批数字货架商品' },
  { value: '99', label: '同步启动云创客招募' },
  { value: '3秒', label: '项目设定的红包到账目标' },
];